import * as React from 'react';

const CenterMapIcon = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 11.818a1.818 1.818 0 1 0 0-3.636 1.818 1.818 0 0 0 0 3.636Z"
      fill="#83858F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0c.502 0 .909.407.909.909v1.875a7.276 7.276 0 0 1 6.307 6.307h1.875a.909.909 0 0 1 0 1.818h-1.875a7.276 7.276 0 0 1-6.307 6.307v1.875a.909.909 0 0 1-1.818 0v-1.875a7.276 7.276 0 0 1-6.307-6.307H.909a.909.909 0 0 1 0-1.818h1.875A7.276 7.276 0 0 1 9.09 2.784V.909C9.091.407 9.498 0 10 0ZM4.546 10a5.455 5.455 0 1 0 10.909 0 5.455 5.455 0 0 0-10.91 0Z"
      fill="#83858F"
    />
  </svg>
);

export default CenterMapIcon;
